export const errorText = (validator: any, messages: Record<string, string>) => {
  if (!validator.$error) {
    return "";
  }

  const error = validator
    .$flattenParams()
    .find(({ name }: any) => !validator[name]);

  if (!error) {
    return "";
  }

  return messages[error.name] || "Error";
};
